module.exports = __webpack_public_path__ + "img/edit.21b41f78.svg";